import { GetterTree } from 'vuex'
import { State } from '@/store/types'

import { Locale, CompanyLang } from '@/types'

import Cookies from 'js-cookie'

import { CookieName } from '@/config/cookies'

export const getters: GetterTree<State, State> = {
  // Global getters
  getLocale(): Locale {
    let locale = window.env.VUE_APP_LOCALE as Locale

    if (locale === 'fr-FR-CSE') {
      const companyLang = Cookies.get(CookieName.COMPANY_LANG) as CompanyLang

      // Assign the locale(lang) based on the cookie
      locale = companyLang === 'nl' ? 'nl-NL' : locale
    }

    return locale
  },
}
